/**
 * Presentation mapping for the existing sample status model
 * (patient_labinvestigation_opd.IsSampleCollected: N / S / Y / R).
 * "Outsourced" is a processing-mode flag on a row, not a status.
 * No business logic here: visual keys only.
 */
export const SAMPLE_STATUS_KEYS = {
  N: 'pending',
  S: 'collected',
  Y: 'received',
  R: 'rejected',
};

export const sampleStatusKey = (sample) => SAMPLE_STATUS_KEYS[sample?.isSampleCollected] || 'pending';

export const isOutsourcedSample = (sample) =>
  Boolean(sample?.isOutsource || sample?.processingMode === 'OUTSOURCE' || sample?.referenceLabName);

/** Row classes: tint by workflow status; outsourced rows also get the outsourced edge marker. */
export const sampleRowStatusClass = (sample) => {
  const key = sampleStatusKey(sample);
  return `st-row-${key}${isOutsourcedSample(sample) && key !== 'rejected' ? ' st-row-outsourced' : ''}`;
};

/** Display names for the existing status filter values (search API `status` parameter). */
export const STATUS_FILTER_LABELS = {
  ALL: 'All',
  N: 'Pending',
  S: 'Collected',
  Y: 'Received',
  R: 'Rejected',
  OUTSOURCE: 'Outsourced',
};
